import * as React from "react";
import styled from "styled-components";
import {ExternalBtn} from "../common/atom/btn/btn_link_corporate_middle";

interface IProps {
    title: string
    text: string
    link: string
}

const Faq: React.FC<IProps> = (props) => {
    return (
        <Container>
            <Title>{props.title}</Title>
            <Content>
                <Text>{props.text}</Text>
                <ButtonLink href={props.link} target={"_blank"}>FAQを見る</ButtonLink>
            </Content>
        </Container>
    )

}

export default Faq;

const Container = styled.div`
    width: 100%;
    background-color: #EAEBF7;
    padding: 16px 24px;
    border-radius: 4px;
    margin-bottom: 20px;
`;

const Title = styled.div`
    font-weight: bold;
    font-size: 15px;
    line-height: 24px;
    margin-bottom: 4px;
`;

const Content = styled.div`
    display: flex;
    align-items: flex-end;
`;

const Text = styled.div`
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
`;

const ButtonLink = styled(ExternalBtn)`
    width: 150px;
    margin-left: 20px;
    text-align: center;
`;


// WEBPACK FOOTER //
// ./src/presentation/component/faq.tsx